import React from "react"
import Table from "./Table"
import LoaderSingleComponent from "../../loader-app/modules/LoaderSingleComponent"
import { rowObjectToRows, niceField } from '../services/api'

const getFieldProp = (fieldsProps, fieldKey) => {
    if (fieldsProps && typeof fieldsProps === 'object' && fieldKey in fieldsProps) {
        return fieldsProps[fieldKey] || {}
    }
    return {}
}

const renderLabelCell = (props, fieldsProps) => {
    const fld = props.row[0]
    const fldProp = getFieldProp(fieldsProps, fld)

    const { nice_name, Header } = fldProp
    if (nice_name) return nice_name
    if (Header) return Header
    return niceField(fld)
}

const renderValueCell = (props, fieldsProps, rowObject) => {
    const fld = props.row[0]
    const fldProp = getFieldProp(fieldsProps, fld)
    
    let val = props.value
    const CustomCell = fldProp.hasOwnProperty('Cell') ? fldProp['Cell'] : null

    // Gestione degli oggetti se non c'è CustomCell (come nella tua versione originale)
    if ((CustomCell === null || CustomCell === undefined) && typeof val === 'object' && val !== null) {
        val = JSON.stringify(val)
    }

    if (CustomCell === null || CustomCell === undefined) {
        return val
    }

    // Se c'è una CustomCell, le passiamo val e l'intero rowObject tramite props
    return (
        <CustomCell
            {...props}
            value={val}
            original={rowObject}
            rowObject={rowObject}
            fieldKey={fld}
        />
    )
}

class TableOneRowTransposed extends React.Component {
    render() {
        const { rowObject = {}, fieldsProps = {}, ...restProps } = this.props

        if (!rowObject || !Object.keys(rowObject).length) {
            return <LoaderSingleComponent width="100%" />
        }

        // 1. Converti l'oggetto in array di righe [chiave, valore]
        let data = rowObjectToRows(rowObject)

        // 2. Filtra i campi nascosti (show === false)
        if (fieldsProps && Object.keys(fieldsProps).length) {
            data = data.filter(([key]) => {
                const prop = fieldsProps[key]
                return !prop || prop.show !== false
            })
        }

        if (!data.length) {
            return <LoaderSingleComponent width="100%" />
        }

        // NOTA: data resta esattamente [key, value] senza elementi aggiunti!

        return (
            <Table
                {...restProps}
                defaultPageSize="100"
                showPaginator={false}
                data={data}
                fieldsProps={{
                    0: { Cell: (props) => renderLabelCell(props, fieldsProps) },
                    1: { Cell: (props) => renderValueCell(props, fieldsProps, rowObject) },
                }}
            />
        )
    }
}

export default TableOneRowTransposed